import { EmploymentInviteeStatusEnum } from 'server/shared/models/employmentInviteeStatusEnum';
import { EmploymentInvitee } from 'server/shared/models/employmentInvitee';

const inviteeStatusOrder: { [key in EmploymentInviteeStatusEnum]?: number } = [
  EmploymentInviteeStatusEnum.BOOKED,
  EmploymentInviteeStatusEnum.AVAILABLE,
  EmploymentInviteeStatusEnum.OPEN,
  EmploymentInviteeStatusEnum.UNAVAILABLE,
  EmploymentInviteeStatusEnum.DECLINED,
  EmploymentInviteeStatusEnum.DECLINED,
  EmploymentInviteeStatusEnum.CANCELLED,
].reduce(
  (acc, status, index) => ({
    ...acc,
    [status]: index,
  }),
  {},
);

export function sortByInviteeStatus(
  a: EmploymentInvitee,
  b: EmploymentInvitee,
): number {
  return (
    (inviteeStatusOrder[a.status] || 0) - (inviteeStatusOrder[b.status] || 0)
  );
}
